import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Section from './shared/Section'
import MiniTable from './MiniTable'

const accountKeyAccessor = acct => acct?.accountId

function AccountSummaryList ({ accounts, selectedDetail, onSelectDetail, columns }) {
  const selected = useMemo(() => {
    if (selectedDetail?.type !== 'account') return null
    return (accounts || []).find(x => selectedDetail?.detail?.accountId === x.accountId) ?? null
  }, [accounts, selectedDetail])
  if (!accounts?.length) {
    return null
  }

  return (
    <Section>
      <header>Accounts</header>
      <MiniTable
        data={accounts}
        columns={columns}
        keyAccessor={accountKeyAccessor}
        selected={selected}
        onSelect={(acct) => onSelectDetail({ type: 'account', detail: acct })}
      />
    </Section>
  )
}

AccountSummaryList.propTypes = {
  accounts: PropTypes.array,
  selectedDetail: PropTypes.any,
  onSelectDetail: PropTypes.func,
  columns: PropTypes.array
}

export default AccountSummaryList
